<input id="{{dataItem.checkboxId}}"
    type="checkbox"
    [checked]="isChecked"
    (change)="onCheckboxChange(dataItem)"/>
